import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	operationVerbalForm: {
		id: 'eoc.rule-card.condition-list.operation-verbal-form.no-translate',
		defaultMessage: `{fieldFreeForm, select,
      false {{field}}
      other {value of {field} in extra properties}
    } {not, select,
        true {{operation, select,
          0 {does not match}
          1 {does not contain}
          3 {does not start with}
          4 {does not end with}
          5 {does not equal}
          6 {does not contain key}
          7 {does not contain value}
          8 {does not greater than}
          9 {does not less than}
          10 {is not empty}
          11 {is not equal ignore whitespace}
          other {}
        }}
        other {{operation, select,
          0 {matches}
          1 {contains}
          3 {starts with}
          4 {ends with}
          5 {equals}
          6 {contains key}
          7 {contains value}
          8 {is greater than}
          9 {less than}
          10 {is empty}
          11 {equals ignore whitespace}
          other {}
        }}
      } {value, select, false {} other {<strong>{value}</strong>}}`,
		description:
			'Full message of operation. Example: message contains important / message does not contains important',
	},
	or: {
		id: 'eoc.rule-card.condition-list.or.no-translate',
		defaultMessage: '<strong>OR </strong>',
		description: '"Or" condition',
	},
	and: {
		id: 'eoc.rule-card.condition-list.and.no-translate',
		defaultMessage: '<strong>AND </strong>',
		description: '"And" condition',
	},
});

export default messages;
